'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var highlightValue = function highlightValue(value, highlights) {
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var classNames = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (!highlights) {
    return _react2.default.createElement(
      'span',
      null,
      value
    );
  }

  if ((0, _isArray3.default)(value)) {
    return value.map(function (v, i) {
      return highlightValue(v, highlights[i], i);
    });
  }

  var val = String(value); // deals with arrays/numbers/...

  var children = [];
  var currentPosition = 0;
  var x = 0;

  for (x = 0; x < highlights.length; x += 1) {
    var nonMatchingPrefix = val.slice(currentPosition, highlights[x].startIndex);
    var matchingText = val.slice(highlights[x].startIndex, highlights[x].startIndex + highlights[x].length);

    currentPosition = highlights[x].startIndex + highlights[x].length;

    if (nonMatchingPrefix.length > 0) {
      children.push(_react2.default.createElement(
        'span',
        { key: x + '-nonmatch' },
        nonMatchingPrefix
      ));
    }
    children.push(_react2.default.createElement(
      'span',
      { className: classNames.highlight || 'highlight', key: x + '-match' },
      matchingText
    ));
  }
  children.push(_react2.default.createElement(
    'span',
    { key: x + '-remainder' },
    val.slice(currentPosition)
  ));

  return _react2.default.createElement(
    'span',
    { className: classNames.searchResult || 'search-result', key: 'result-' + index },
    children
  );
};

exports.default = highlightValue;